const pickRandomItem = <TItem>(items: readonly TItem[]): TItem => {
  const index = Math.floor(Math.random() * items.length);
  return items[index];
};

const buildQaError = ({
  message,
  stackLines,
}: {
  message: string;
  stackLines: string[];
}): Error => {
  const error = new Error(message);
  error.stack = ["Error: " + message, ...stackLines].join("\n");
  return error;
};

const QA_ERROR_BUILDERS: readonly (() => Error)[] = [
  () =>
    buildQaError({
      message: "Failed to load ride production metadata",
      stackLines: [
        "    at loadProductionMetadata (production.service.ts:142:11)",
        "    at async produceRidesBatch (produce-rides.ts:88:5)",
        "    at async handleProduceClick (ride-produce.panel.tsx:56:3)",
      ],
    }),
  () =>
    buildQaError({
      message: "Cannot read properties of undefined (reading 'stationId')",
      stackLines: [
        "    at normalizeWaypoint (station-route.helpers.ts:301:22)",
        "    at mapStationRouteRow (station-route.row.tsx:47:18)",
        "    at renderWithHooks (react-dom.development.js:15486:18)",
      ],
    }),
  () =>
    buildQaError({
      message: "Network request failed: GET /api/v1/bookings/calendar",
      stackLines: [
        "    at axiosInterceptor (api.client.ts:92:15)",
        "    at async fetchBookingsCalendar (bookings-calendar.api.ts:24:9)",
        "    at async loadCalendarPage (bookings-calendar.wrapper.tsx:118:7)",
      ],
    }),
  () =>
    buildQaError({
      message: "Maximum update depth exceeded",
      stackLines: [
        "    at dispatchSetState (react-dom.development.js:16708:7)",
        "    at useInfluencedInput (use-influenced-input.ts:198:5)",
        "    at DropdownTemplate (dropdown.template.tsx:62:31)",
      ],
    }),
];

export const createRandomQaError = (): Error => {
  const builder = pickRandomItem(QA_ERROR_BUILDERS);
  return builder();
};
